import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";

import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { WebAppLayout } from "./components/WebAppLayout";

import { HomePage } from "./pages/HomePage";

import {
  RegisterPage,
  LoginPage,
  CheckEmailPage,
  VerifyPage,
  ForgotPasswordPage,
  RecoveryPage,
} from "./pages/AuthPages";

import { AccountPage } from "./pages/AccountPage";
import { AdminPage } from "./pages/AdminPage";

import {
  FeaturesPage,
  PricingPage,
  PrivacyPage,
  TermsPage,
  SupportPage,
  NotFoundPage,
} from "./pages/StaticPages";

import {
  TodayPage,
} from "./pages/WebAppPages";

import {
  CalendarPage,
} from "./pages/CalendarPage";

import {
  CountdownPage,
} from "./features/countdowns";

import {
  RoutinesPage,
} from "./features/routines/RoutinesPage";

import {
  ProfilePage,
} from "./features/profile/ProfilePage";

import {
  SubscriptionPage,
} from "./features/subscrition";

import {
  EventCirclePage,
} from "./features/event-circle/EventCirclePage";

import {
  EventCircleInvitationPage,
} from "./features/event-circle/EventCircleInvitationPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* A shared Event Circle link can be opened
              by anyone. The backend checks their account
              before private access or a response is allowed. */}
          <Route
            path="/invite/:token"
            element={<EventCircleInvitationPage />}
          />

          <Route element={<Layout />}>
            <Route
              path="/"
              element={<HomePage />}
            />

            <Route
              path="/features"
              element={<FeaturesPage />}
            />

            <Route
              path="/pricing"
              element={<PricingPage />}
            />

            <Route
              path="/support"
              element={<SupportPage />}
            />

            <Route
              path="/privacy"
              element={<PrivacyPage />}
            />

            <Route
              path="/terms"
              element={<TermsPage />}
            />

            <Route
              path="/register"
              element={<RegisterPage />}
            />

            <Route
              path="/login"
              element={<LoginPage />}
            />

            <Route
              path="/check-email"
              element={<CheckEmailPage />}
            />

            <Route
              path="/forgot-password"
              element={<ForgotPasswordPage />}
            />

            <Route
              path="/saradium/verify"
              element={<VerifyPage />}
            />

            <Route
              path="/saradium/recovery"
              element={<RecoveryPage />}
            />

            <Route element={<ProtectedRoute />}>
              <Route
                path="/account"
                element={<AccountPage />}
              />
            </Route>

            <Route
              path="*"
              element={<NotFoundPage />}
            />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route
              path="/app"
              element={<WebAppLayout />}
            >
              <Route
                index
                element={<TodayPage />}
              />

              <Route
                path="today"
                element={<TodayPage />}
              />

              <Route
                path="routines"
                element={<RoutinesPage />}
              />

              <Route
                path="countdowns"
                element={<CountdownPage />}
              />

              <Route
                path="calendar"
                element={<CalendarPage />}
              />

              <Route
                path="event-circle"
                element={<EventCirclePage />}
              />

              <Route
                path="profile"
                element={<ProfilePage />}
              />

              {/* Settings belong to Profile but this keeps
                  older links working. */}
              <Route
                path="settings"
                element={<ProfilePage />}
              />

              <Route
                path="subscription"
                element={<SubscriptionPage />}
              />
            </Route>

            <Route
              path="/admin"
              element={<AdminPage />}
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}